import { useParams } from 'react-router';

import type { TypeEngineAgent } from '@intone/shared/types';

import { useEngineAgent } from '@/entities/engineAgent';

import { AgentForm } from './AgentForm';
import { PageHeader } from './PageHeader';

export function AgentEditorPage() {
  const { agentId } = useParams();
  const { data: agent = {} as TypeEngineAgent, isLoading, isSuccess } = useEngineAgent(agentId);

  if (isLoading) {
    return (
      <div className="w-full h-full p-4 overflow-y-auto">
        <PageHeader/>
        <div className="flex items-center justify-center mt-6">
          <div className="text-gray-600">Loading...</div>
        </div>
      </div>
    );
  }

  if (!isSuccess || !agentId) {
    return (
      <div className="w-full h-full p-4 overflow-y-auto">
        <PageHeader/>
        <div className="flex items-center justify-center mt-6">Agent not found</div>
      </div>
    );
  }

  return (<AgentForm agentId={agentId} agent={agent}/>);
}